import api from "../../../api";

export const flatAllFiles = (filesets: (api.SignatureFileSet | api.UploadedDocument)[]) =>
  filesets.flatMap((fileset) => fileset.files.map((file) => ({ file, fileset })));

export const getFileName = (file: api.CustomerFile | api.File) => ("filename" in file ? file.filename : file.file_name);

export const getFilesetType = (fileset: api.SignatureFileSet | api.UploadedDocument) =>
  "document_type" in fileset ? fileset.document_type : (fileset.type as api.SignatureFileSetDocumentType);
